import { Reveal, Eyebrow } from "./Reveal";

const PRINCIPLES = [
  {
    title: "Complementary, Not Primary",
    desc: "Principal investing sits alongside — never ahead of — the firm's advisory core. Advisory mandates always take precedence.",
  },
  {
    title: "Selective & High-Conviction",
    desc: "A small number of direct investments and co-investments where detailed assessment identifies genuine opportunity.",
  },
  {
    title: "Aligned With Partners",
    desc: "Investments are pursued where the firm has the appropriate capital resources and structures, alongside partners on identical terms.",
  },
];

export const InvestmentsApproach = () => (
  <section id="investments" data-testid="investments-section" className="relative py-28 lg:py-44">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>Principal Investments</Eyebrow>
            <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08]">
              Selective <span className="italic">Principal Capital.</span>
            </h2>
            <p className="mt-8 text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              Alongside its advisory activities, PJG pursues selective direct investments and
              co-investments, where the firm has the appropriate capital resources and structures.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="border-t border-[#E3E0D8]">
            {PRINCIPLES.map((p, i) => (
              <Reveal key={p.title} delay={0.1 + i * 0.08}>
                <div className="py-9 lg:py-10 border-b border-[#E3E0D8] flex gap-6" data-testid={`investment-principle-${i}`}>
                  <span className="font-sans text-[11px] tracking-[0.24em] text-[#6E6A61] pt-1">0{i + 1}</span>
                  <div>
                    <h3 className="font-serif text-xl sm:text-2xl font-light text-[#1F1E1B]">{p.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-[#6E6A61]">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.35}>
            <p className="mt-8 border-l-2 border-[#1F1E1B]/25 pl-6 text-xs leading-relaxed text-[#6E6A61] tracking-wide">
              PJG Capital Partners maintains a clear distinction between independent advisory mandates and
              transactions in which it invests as principal. Where a potential conflict of interest arises,
              it is disclosed and addressed with the relevant parties before engagement. Principal
              investments are made on a bespoke, deal-by-deal basis; the firm does not manage a commingled
              fund.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
